import React from "react";
import { Line as LineJS } from "chart.js/auto";
import { Pie } from "react-chartjs-2";
// import HeadTitle from "../global/HeadTitle";

function PieChart({ data }) {
  const dataObj = {
    labels: ["تم", "قيد الانتظار", "لم يتم"],
    datasets: [
      {
        label: "# of Votes",
        data: [
          data.orders_competed,
          data.orders_cancelled,
          data.orders_pending,
        ],
        backgroundColor: ["#0C9700", "#FF002E", "#FF8900"],
        borderColor: ["#0C9700", "#FF002E", "#FF8900"],
      },
    ],
  };

  return (
    <div className="pie-chart">
      {/* <HeadTitle title=" احصائيات طلبات الخدمات " margin={true} /> */}

      <Pie id="pie" data={dataObj} />
    </div>
  );
}
export default PieChart;
